var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Layout, Dependencies } from "~/core/decorator";
import { PageService } from "~/utils/page.service";
import { SortService } from "~/utils/sort.service";
import NumberRange from "~/components/common/number-range.vue";
import { SynthesizeQueryService } from "~/services/domain-service/synthesize-query.service";
import { namespace, Getter } from "vuex-class";
import { UserService } from "~/services/management-service/user.service";
var CollectionExecutionModule = namespace('collection-execution');
var RepaymentRecordQuery = /** @class */ (function (_super) {
    __extends(RepaymentRecordQuery, _super);
    function RepaymentRecordQuery() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.totalInfo = {};
        _this.searchModel = {
            deptCodes: [],
            collectorId: "",
            caseMoney: { min: '', max: '' }
        };
        _this.dataSet = [];
        _this.userDataSet = [];
        _this.userModel = {
            deptCode: ""
        };
        return _this;
    }
    RepaymentRecordQuery.prototype.queryTotalAmount = function () {
        var _this = this;
        this.synthesizeQueryService
            .getTotalRepayment(this.searchModel)
            .subscribe(function (data) { return (_this.totalInfo = data); });
    };
    RepaymentRecordQuery.prototype.queryRepaymentRecord = function () {
        var _this = this;
        this.synthesizeQueryService
            .queryRepaymentRecord(this.searchModel, this.pageService)
            .subscribe(function (data) { return (_this.dataSet = data); });
    };
    RepaymentRecordQuery.prototype.refreshData = function () {
        this.queryRepaymentRecord();
        this.queryTotalAmount();
    };
    RepaymentRecordQuery.prototype.handleResetForm = function () {
        this.searchModel.caseMoney = { min: '', max: '' };
    };
    RepaymentRecordQuery.prototype.mounted = function () {
        if (!(this.departmentData[0].deptCode)) {
            return;
        }
        this.searchModel.deptCodes.push(this.departmentData[0].deptCode);
        this.getAllUserByDeptCode();
        this.refreshData();
    };
    RepaymentRecordQuery.prototype.getAllUserByDeptCode = function () {
        var _this = this;
        if (this.searchModel.deptCodes.length === 0) {
            return;
        }
        this.userModel.deptCode = this.searchModel.deptCodes[this.searchModel.deptCodes.length - 1];
        this.userService
            .getAllUsers(this.userModel, this.pageService)
            .subscribe(function (data) {
            _this.userDataSet = data;
        });
    };
    RepaymentRecordQuery.prototype.changeDept = function () {
        this.getAllUserByDeptCode();
    };
    __decorate([
        Dependencies(PageService)
    ], RepaymentRecordQuery.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], RepaymentRecordQuery.prototype, "sortService", void 0);
    __decorate([
        Dependencies(SynthesizeQueryService)
    ], RepaymentRecordQuery.prototype, "synthesizeQueryService", void 0);
    __decorate([
        Dependencies(UserService)
    ], RepaymentRecordQuery.prototype, "userService", void 0);
    __decorate([
        Getter
    ], RepaymentRecordQuery.prototype, "departmentData", void 0);
    __decorate([
        Getter
    ], RepaymentRecordQuery.prototype, "isSupperAdmin", void 0);
    RepaymentRecordQuery = __decorate([
        Layout("workspace"),
        Component({
            components: {
                NumberRange: NumberRange
            }
        })
    ], RepaymentRecordQuery);
    return RepaymentRecordQuery;
}(Vue));
export default RepaymentRecordQuery;
